import { render, staticRenderFns } from "./UpdateSurveyForm.vue?vue&type=template&id=bfc07984&scoped=true"
import script from "./UpdateSurveyForm.vue?vue&type=script&lang=js"
export * from "./UpdateSurveyForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateSurveyForm.vue?vue&type=style&index=0&id=bfc07984&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc07984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc07984')) {
      api.createRecord('bfc07984', component.options)
    } else {
      api.reload('bfc07984', component.options)
    }
    module.hot.accept("./UpdateSurveyForm.vue?vue&type=template&id=bfc07984&scoped=true", function () {
      api.rerender('bfc07984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey_form/dialog/UpdateSurveyForm.vue"
export default component.exports